import { Controller } from "@hotwired/stimulus";

// 検索フォームの日付範囲(開始〜終了)が逆転している場合、送信前にメッセージを表示して送信ボタンを無効化する。
// 範囲ごとに range ターゲット(data-message にメッセージ文言)を置き、その中の start/end 入力と message 要素を参照する。
export default class extends Controller<HTMLFormElement> {
  static targets = ["range"];

  declare readonly rangeTargets: HTMLElement[];

  connect(): void {
    this.validate();
  }

  validate(): void {
    let allValid = true;

    this.rangeTargets.forEach((range) => {
      const start = range.querySelector<HTMLInputElement>("[data-range-role='start']")?.value || "";
      const end = range.querySelector<HTMLInputElement>("[data-range-role='end']")?.value || "";
      const message = range.querySelector<HTMLElement>("[data-range-role='message']");
      const invalid = start !== "" && end !== "" && start > end;

      if (message) {
        message.textContent = invalid ? range.dataset.message || "" : "";
        message.classList.toggle("hidden", !invalid);
      }
      if (invalid) allValid = false;
    });

    this.element.querySelectorAll<HTMLInputElement>("[type='submit']").forEach((button) => {
      button.disabled = !allValid;
    });
  }
}
